import { GameObject } from "../../tsthree";
import { Container, Graphics, Sprite, Texture } from "pixi.js";
import { tsthreeConfig } from "../../config/tsthreeConfig";

export class Scopey extends GameObject {

    public mainSprite: Sprite;

    private leftEyeContainer: Container;
    private rightEyeContainer: Container;
    private leftEyeBg: Graphics;
    private leftInnerEyeBg: Graphics;
    private rightEyeBg: Graphics;
    private rightInnerEyeBg: Graphics;

    private timer: number = 0;

    constructor() {
        super();

        const scopey =
            this.mainSprite =
                new Sprite(ENGINE.getPIXIResource("scopey") as Texture);
        scopey.anchor.set(1, 1);
        this.addChild(scopey);

        const leftEyeContainer = this.leftEyeContainer = new Container();
        leftEyeContainer.position.set(
            -(this.width) + 74,
            -(this.height) + 25,
        );

        const rightEyeContainer = this.rightEyeContainer = new Container();
        rightEyeContainer.position.set(
            -100,
            -(this.height) + 35,
        );

        scopey.addChild(leftEyeContainer);
        scopey.addChild(rightEyeContainer);

        const leftEyeBg = this.leftEyeBg = new Graphics();
        leftEyeBg.beginFill(0xfafafa, 1);
        leftEyeBg.drawCircle(0, 0, 22);
        leftEyeBg.endFill();
        leftEyeBg.scale.set(2);
        leftEyeContainer.addChild(leftEyeBg);
        const leftEye = this.leftInnerEyeBg = new Graphics();
        leftEye.beginFill(0x010101, 1);
        leftEye.drawCircle(0, 0, 11);
        leftEye.endFill();
        leftEye.scale.set(2);
        leftEye.position.set(-10, 10);
        leftEyeContainer.addChild(leftEye);

        const rightEyeBg = this.rightEyeBg = new Graphics();
        rightEyeBg.beginFill(0xfafafa, 1);
        rightEyeBg.drawCircle(0, 0, 22);
        rightEyeBg.endFill();
        rightEyeBg.scale.set(2);
        rightEyeContainer.addChild(rightEyeBg);
        const rightEye = this.rightInnerEyeBg = new Graphics();
        rightEye.beginFill(0x010101, 1);
        rightEye.drawCircle(0, 0, 11);
        rightEye.endFill();
        rightEye.scale.set(2);
        rightEye.position.set(-10, 10);
        rightEyeContainer.addChild(rightEye);

        this.leftEyeBg.cacheAsBitmap = true;
        this.rightEyeBg.cacheAsBitmap = true;
        this.rightInnerEyeBg.cacheAsBitmap = true;
        this.leftInnerEyeBg.cacheAsBitmap = true;
    }

    onStep(_dt: number) {
        super.onStep(_dt);
        this.timer += _dt;
        this.leftInnerEyeBg.position.set(
            -10 + (Math.sin(this.timer * 0.04) * 1),
            10 + (Math.sin(this.timer * 0.08) * 1),
        );
        this.rightInnerEyeBg.position.set(
            -10 + (Math.sin(this.timer * 0.04) * 1),
            10 + (Math.sin(this.timer * 0.08) * 1),
        );
        this.mainSprite.x = Math.sin(this.timer * 0.02) * 2.5;
        this.mainSprite.y = Math.sin(this.timer * 0.04) * 2.5;
    }
}